import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * cn — combine Tailwind class names with smart de-duplication.
 * Same helper as shadcn-ui uses; clsx handles conditionals,
 * tailwind-merge resolves conflicts (e.g. `p-2 p-4` → `p-4`).
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
